import { useGameContext } from '../../libs/GameProvider';
import './GamePaperMaking.scss';
import GamePaperMakingCover from './GamePaperMakingCover';
import GamePaperMakingFail from './GamePaperMakingFail';
import GamePaperMakingGame from './GamePaperMakingGame';
import GamePaperMakingSuccess from './GamePaperMakingSuccess';

interface GamePaperMakingProps {
  children?: React.ReactNode;
  style?: React.CSSProperties;
  // stage: 0 | 1 | 2;
  onFinish?: () => void;
}

function GamePaperMaking(_props: GamePaperMakingProps) {
  const { game, gameDifficulty } = useGameContext();

  return (
    <div className={`game-area game-paper-making game-paper-making-difficulty-${gameDifficulty.difficulty}`}>
      {'game-paper-making' === game.status ? <>
        {'cover' === game.state
          ? <GamePaperMakingCover />
          : 'fail' === game.state
            ? <GamePaperMakingFail />
            : 'success' === game.state
              ? <GamePaperMakingSuccess />
              : <GamePaperMakingGame />
        }
      </> : null}
    </div>
  )
}

export default GamePaperMaking;
